/**
 * API 基础地址配置
 *
 * 优先级：
 * 1. 构建时通过 .env/.env.production 注入的 VUE_APP_API_BASE
 * 2. 运行时默认回退到本地后端 http://localhost:8003
 *
 * 本地/线上切换方式：
 * - npm run serve          -> 使用 .env 中的本地地址
 * - npm run build          -> 使用 .env.production 中的线上地址
 * - npm run serve:prod     -> 以 production 模式启动，使用线上地址
 * - npm run build:local    -> 以 development 模式打包，使用本地地址
 * - 也可以在 frontend/.env.local 中临时覆盖 VUE_APP_API_BASE
 */
export const API_BASE = process.env.VUE_APP_API_BASE || 'http://localhost:8003'
